import ReactDOM from 'react-dom';
import Countdown from 'react-countdown';
import React from "react";

function MyCountdown() {
    const Completionist = () => <span>You are good to go!</span>;

    // Renderer callback with condition
    const renderer = ({ days, hours, minutes, seconds, completed }) => {
        if (completed) {
            // Render a completed state
            return <Completionist />;
        } else {
            // Render a countdown
            return <div className="grid grid-cols-4 w-full sm:w-[calc(100%-115px)]">
                <div className="text-center"><div className="font-bold text-2xl">{days}</div><div>Днів</div></div>
                <div className="text-center"><div className="font-bold text-2xl">{hours}</div><div>Годин</div></div>
                <div className="text-center"><div className="font-bold text-2xl">{minutes}</div><div>Хвилин</div></div>
                <div className="text-center"><div className="font-bold text-2xl">{seconds}</div><div>Секунд</div></div>
            </div>;
        }
    };

    return (
        <div className="sm:flex flex-wrap justify-center items-center mb-4">
            <div className="w-full sm:w-[100px] mr-[15px] text-center sm:text-right mb-4 sm:mb-0">
                До івенту
                лишилось
            </div>
            <Countdown
                date={Date.now() + (new Date('2025-04-11T23:59:59') - Date.now())}
                renderer={renderer}
            />
        </div>
    )
}

export default MyCountdown